import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import "../css/ProgressiveData.css";
import { userData, focusElement, progressiveDataStructure } from "../js/utils";
import { post } from "../js/post";

export default function ProgressiveData({ id, onClose }) {
  const [currentProgressiveData, setCurrentProgressiveData] = useState(
    progressiveDataStructure,
  );

  const handleValue = (field, value) => {
    setCurrentProgressiveData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const getProgressiveData = async () => {
    const response = await post(
      "/support-extra/fichas/ObtenerDatosProgresivos.php",
      {
        token: userData.token,
        idFicha: id,
      },
    );
    setCurrentProgressiveData(
      Object.keys(response).length > 0 ? response : progressiveDataStructure,
    );
  };

  const saveProgressiveData = async () => {
    const response = await post(
      "/support-extra/fichas/GuardarDatosProgresivos.php",
      {
        token: userData.token,
        idFicha: id,
        ...currentProgressiveData,
      },
    );
    if (response.idDatoProgresivo) {
      getProgressiveData();
    }
  };

  const deleteProgressiveData = async () => {
    await post("/support-extra/fichas/EliminarDatosProgresivos.php", {
      token: userData.token,
      idFicha: id,
    });
  };

  useEffect(() => {
    focusElement(300);
    getProgressiveData();
  }, []);

  return (
    <div className="pd-container container-panel">
      <div className="pd-container-info opt-table-content grid-6">
        <div className="cell combined-cells-2"></div>
        <div className="cell opt-table-subtitle">OD</div>
        <div className="cell opt-table-subtitle">AO</div>
        <div className="cell opt-table-subtitle">OI</div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">
          Distancia de vértice
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={300}
            type="type-float2"
            size={6}
            input={currentProgressiveData.distanciaVerticeD}
            onChange={(e) => {
              handleValue("distanciaVerticeD", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">mm</div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={302}
            type="type-float2"
            size={6}
            input={currentProgressiveData.distanciaVerticeI}
            onChange={(e) => {
              handleValue("distanciaVerticeI", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">mm</div>
        <div className="cell cell-label cell-start-content">Coeficiente HE</div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={303}
            type="type-integer"
            size={6}
            input={currentProgressiveData.coeficienteCabezaOjo}
            onChange={(e) => {
              handleValue("coeficienteCabezaOjo", e);
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-label cell-start-content">Coeficiente ST</div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={304}
            type="type-integer"
            size={6}
            input={currentProgressiveData.coeficienteEstabilidad}
            onChange={(e) => {
              handleValue("coeficienteEstabilidad", e);
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-label cell-start-content">
          Distancia de lectura
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={305}
            type="type-integer"
            size={6}
            input={currentProgressiveData.distanciaLectura}
            onChange={(e) => {
              handleValue("distanciaLectura", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content combined-cells-2">
          cm
        </div>
        <div className="cell cell-label cell-start-content">
          Ángulo Pantoscópico
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={306}
            type="type-float2"
            size={6}
            input={currentProgressiveData.anguloPantoscopico}
            onChange={(e) => {
              handleValue("anguloPantoscopico", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content combined-cells-2">
          °
        </div>
        <div className="cell cell-label cell-start-content">
          Ángulo de Galbe
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={307}
            type="type-float2"
            size={6}
            input={currentProgressiveData.anguloGalbe}
            onChange={(e) => {
              handleValue("anguloGalbe", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content combined-cells-2">
          °
        </div>
        <div className="cell cell-label cell-start-content">
          Longitud de progresión
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={60}
            tabIndex={308}
            type="type-integer"
            size={6}
            input={currentProgressiveData.longitudProgresion}
            onChange={(e) => {
              handleValue("longitudProgresion", e);
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-label cell-start-content">Eyecode</div>
        <div className="cell combined-cells-2"></div>
        <div className="cell">
          <CheckBox
            tabIndex={309}
            active={currentProgressiveData.eyeCode}
            onClick={() => {
              handleValue("eyeCode", !currentProgressiveData.eyeCode);
            }}
          ></CheckBox>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-label cell-start-content">Ojo dominante</div>
        <div className="cell"></div>
        <div className="cell">
          <CheckBox
            tabIndex={310}
            active={currentProgressiveData.ojoDominante === "D"}
            onClick={() => {
              handleValue("ojoDominante", "D");
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell">
          <CheckBox
            tabIndex={311}
            active={currentProgressiveData.ojoDominante === "I"}
            onClick={() => {
              handleValue("ojoDominante", "I");
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Grabados</div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={20}
            tabIndex={312}
            type="type-alphanum-ext"
            size={6}
            input={currentProgressiveData.grabadosD}
            onChange={(e) => {
              handleValue("grabadosD", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <InputData
            maxLength={20}
            tabIndex={313}
            type="type-alphanum-ext"
            size={6}
            input={currentProgressiveData.grabadosI}
            onChange={(e) => {
              handleValue("grabadosI", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Iniciales</div>
        <div className="cell combined-cells-2"></div>
        <div className="cell">
          <InputData
            maxLength={5}
            tabIndex={314}
            type="type-alphanum-ext"
            size={6}
            input={currentProgressiveData.iniciales}
            onChange={(e) => {
              handleValue("iniciales", e);
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell cell-label cell-start-content">Distancia CRO</div>
        <div className="cell"></div>
        <div className="cell">
          <InputData
            maxLength={60}
            tabIndex={315}
            type="type-integer"
            size={6}
            input={currentProgressiveData.distanciaCROD}
            onChange={(e) => {
              handleValue("distanciaCROD", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">cm</div>
        <div className="cell">
          <InputData
            maxLength={60}
            tabIndex={316}
            type="type-integer"
            size={6}
            input={currentProgressiveData.distanciaCROI}
            onChange={(e) => {
              handleValue("distanciaCROI", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">cm</div>
        <div className="cell cell-label cell-start-content">Ángulo cabeza</div>
        <div className="cell combined-cells-2"></div>
        <div className="cell">
          <InputData
            maxLength={60}
            tabIndex={317}
            type="type-float2"
            size={6}
            input={currentProgressiveData.anguloCabeza}
            onChange={(e) => {
              handleValue("anguloCabeza", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content combined-cells-2">
          °
        </div>
      </div>
      <div className="popup-buttons">
        <ButtonIconH
          text="Eliminar"
          onClick={async () => {
            await deleteProgressiveData();
            onClose();
          }}
        ></ButtonIconH>
        <ButtonIconH
          text="Limpiar"
          onClick={() => {
            setCurrentProgressiveData(progressiveDataStructure);
            focusElement(1);
          }}
        ></ButtonIconH>
        <ButtonIconH
          text="Guardar"
          onClick={async () => {
            await saveProgressiveData();
            onClose();
          }}
        ></ButtonIconH>
      </div>
    </div>
  );
}
